import { Exclude, Expose } from '../serialization/class-transformer/decorators';
import { ServiceRequest } from './service-request';

@Exclude()
export class GenericServiceRequest<TRequestData> extends ServiceRequest {

    @Expose()
    requestData: TRequestData;
}
